import { useQuery } from '@tanstack/react-query';
import { ctcAdjustmentApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';
import { CtcQueryOverrides } from 'src/api/queries/ctc/ctcSnapshotOptions';

/** @registry Cost-code adjustments recorded against a CTC job. */
export function useCtcAdjustments(
  jobNumber: string | null | undefined,
  overrides?: CtcQueryOverrides,
) {
  return useQuery({
    queryKey: queryKeys.ctc.adjustments(jobNumber ?? ''),
    queryFn: ({ signal }) =>
      ctcAdjustmentApiClient.getAdjustments(jobNumber!, toCancelToken(signal)),
    enabled: !!jobNumber,
    staleTime: 0,
    ...overrides,
    meta: { errorContext: 'CTC adjustments' },
  });
}
